import DescriptionBanner from '../Components/DescriptionBanner';
import EndpointsTable from '../Components/Table/EndpointsTable';
import { useTranslation } from 'react-i18next';

export default function PluginAdmin() {

    const { t } = useTranslation();

    return (
        <div className="space-y-4 sm:space-y-6 p-2 sm:p-6 items-stretch">
            <div>
                <DescriptionBanner title={t('pluginAdmin')} description={t('DescrBann_PluginAdmin')} />
            </div>
            <div data-tour="pluginadmin-table">
                <EndpointsTable />
            </div>
        </div>
    );
};
